import * as types from './types';

const initialState = {
  itemNames: [],
  itemCategories: [],
  states: [],
  licenseNumbers: [],
};

const filtersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ITEM_NAMES: {
      const { data: itemNames } = action;
      return { ...state, itemNames };
    }
    case types.SET_ITEM_CATEGORIES: {
      const { data: itemCategories } = action;
      return { ...state, itemCategories };
    }
    case types.SET_STATES: {
      const { data: states } = action;
      return { ...state, states };
    }
    case types.SET_LICENSE_NUMBERS: {
      const { data: licenseNumbers } = action;
      return { ...state, licenseNumbers };
    }
    case types.SET_QUANTITY_TYPES: {
      const { data: quantityTypes } = action;
      return { ...state, quantityTypes };
    }
    default:
      return state;
  }
};

export default filtersReducer;
